import { useResourcesControllerGetStudentStatusesQuery } from '@api/admin/adminGeneratedApi';

export const useGetStatuses = () => {
  const { data, isLoading } = useResourcesControllerGetStudentStatusesQuery();

  return { data, isLoading };
};
